import React, { useState, useEffect, useContext } from "react";
import AdminContext from "../../../StateContext/Application";
import { apiurl } from "../../../../../path";
import {
  Excel32,
  JPG32,
  PNG32,
  PDF32,
  UpdateWhite32,
} from "../../../../../public/LoginImages/importimages";
// 18-09
import { Edit32WHITE, Approved32 } from "../../../../../public/LoginImages/importimages";
import LimitAllocation from "./LimitAllocation.js";
const LimitAllocationOutwardList = () => {
  const context = useContext(AdminContext);
  const { GetAllFundList, Usermenu, ReleaseFromFinanceApproval  } = context;
  const [fund, setfundList] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  // 18-09
  const [openEdit, setOpenEdit] = useState(false);
const [editData, setEditData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

  const [remark, setRemark] = useState("");
  const [menuData, setMenuData] = useState({});

  useEffect(() => {
    const getMenu = async () => {
      const res = await Usermenu();
      console.log(res);
      setMenuData(res.Data);
    };
    getMenu();
  }, []);

  
  const isAgencyChecker =
  menuData?.Department_Name === "Agency Checker" &&
  menuData?.Role === "Agency Checker";

const isStateChecker =
  menuData?.Department_Name === "State Checker" &&
  menuData?.Role === "State Checker";

const isChecker = isAgencyChecker || isStateChecker;

  // 23-10 after state acces 
  const isAgencyMaker =
  menuData?.Department_Name === "Agency Maker" &&
  menuData?.Role === "Agency Maker";

const isStateMaker =
  menuData?.Department_Name === "State Maker" &&
  menuData?.Role === "State Maker";

const isMaker = isAgencyMaker || isStateMaker;

  const getFundList = async () => {
  try {
    let data = await GetAllFundList();
    console.log("API data:", data);
 
    // 23-10
     const list = Array.isArray(data) ? data : data?.result || [];
    const latestFirst = [...list].reverse();
 
    setfundList(latestFirst);
    setFilteredBills(latestFirst);
    setCurrentPage(1);
  } catch (error) {
    console.log("Error fetching fund list:", error);
    setfundList([]);
    setFilteredBills([]);
  }
};
  useEffect(() => {
    getFundList();
  }, []);
  let fundList = [];
  if (fund.length > 0) {
    fundList = fund;
  }

  // above usefect comment for sattus filter 16-09
 useEffect(() => {
    const lowerSearchTerm = searchTerm.toLowerCase();
 
    const filtered = fund.filter((bill) => {
        const matchesSearch = Object.values(bill).some((val) =>
            (val || "").toString().toLowerCase().includes(lowerSearchTerm)
        );
 
        const matchesStatus =
            statusFilter === "All" ||
            (bill.Status || "").toLowerCase() === statusFilter.toLowerCase();
 
        return matchesSearch && matchesStatus;
    });
 
    setFilteredBills(filtered);
    setCurrentPage(1);
}, [searchTerm, statusFilter, fund]);
  const getPageNumbers = (currentPage, totalPages) => {
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    // Page 1, 2, 3
    if (currentPage <= 3) {
      return [1, 2, 3, 4, 5, "...", totalPages];
    }

    // Last 3 pages
    if (currentPage >= totalPages - 2) {
      return [
        "...",
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      ];
    }

    // Middle pages
    return [
      "...",
      currentPage - 2,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      currentPage + 2,
      "...",
      totalPages,
    ];
  };

  // 18-09
  const handleEditFund = (fund) => {
  setEditData(fund);
  setOpenEdit(true);
};

const handleApproveFund = async (fund) => {
  const shouldProceed = window.confirm("Are you sure you want to approve this Limit Allocation?");
  if (!shouldProceed) return;

  try {
    const response = await ReleaseFromFinanceApproval([fund.UniqueID], "Approved", "");
    if (response?.message) alert(response.message);
    else if (response?.error) alert(response.error);
    getFundList(); // refresh list
  } catch (err) {
    console.error("Error approving Limit Allocation:", err);
    alert("An error occurred while approving.");
  }
};

const thStyle = {
  padding: "7px 10px",
  position: "sticky",
    top: 0,     
  zIndex: 2,
};
    return (
      <>
        {!openEdit ? (
      <div
           style={{
    width: "100%",
    maxWidth: "100%",
    maxHeight: "90vh",
    boxSizing: "border-box",
    overflowY: "auto",        // was overflow: "hidden"
    overflowX: "hidden",
    padding: "20px 25px",
    fontFamily: "Inter, sans-serif",
    background: "#fff",
  }}
      >
           <div
        style={{
  width: "100%",
  background: "#EEF1F6",
  borderRadius: "12px",
  padding: "18px 15px",
  boxSizing: "border-box",
  boxShadow: "0 3px 10px rgba(0, 0, 0, 0.10)",
  border: "1px solid #E1E6EF",
  display: "flex",          // add
  flexDirection: "column",  // add
  flex: 1,                  // add
  minHeight: 0,             // add
}}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "12px",
            padding: "0 5px",
            width: "100%",
            boxSizing: "border-box",
            flexShrink:0
          }}
        >
          <h5
            style={{
              fontWeight: "bold",
              color: "black",
              display: "flex",
              alignItems: "center",
            }}
          >
            {/* <img
              src={"/List-32.png"}
              alt="Project Icon"
              style={{ marginRight: "10px", width: 28, height: 28 }}
            /> */}
            {/* 07-10 */}
             <img
      src="/Limit-Allocation-Inward-List-32.png"
      alt="Limit Inward List"
      style={{
        width: "26px",
        height: "26px",
        marginRight: "8px",
        objectFit: "contain",
      }}
    />
            Limit Outward List
          </h5>
  
          {/* ---- Search Box ---- */}
           <div style={{display:"flex",justifyContent:"center",gap:"10px"}}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "white",
              border: "1px solid #ccc",
              borderRadius: "5px",
              padding: "5px 10px",
              width: "250px",
            }}
          >
            <img
              src={"/Search-32.png"}
              alt="Search Icon"
              style={{ width: 20, height: 20, marginRight: "8px" }}
            />
            <input
              type="text"
              placeholder="Search Fund..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                border: "none",
                outline: "none",
                background: "transparent",
                width: "100%",
                fontSize: "12px",
              }}
            />
          </div>
          <select
      value={statusFilter}
      onChange={(e) => setStatusFilter(e.target.value)}
      style={{
          width: "140px",
          height: "36px",
          marginLeft: "10px",
          border: "1px solid #d5dce5",
          borderRadius: "8px",
          padding: "0 10px",
          fontSize: "12px",
          outline: "none",
          background: "#fff",
          cursor: "pointer"
      }}
  >
      <option value="All">All Status</option>
      <option value="Pending">Pending</option>
      <option value="SendBack">SendBack</option>
      <option value="Approved">Approved</option>
      <option value="Rejected">Rejected</option>
  </select></div>
        </div>
  
        <div
          style={{
            width: "100%",
            maxWidth: "100%",
            boxSizing: "border-box",
            backgroundColor: "#fff",
            padding: "18px 10px 12px",
            borderRadius: "12px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.12)",
            overflow: "hidden",
             display: "flex",             
    flexDirection: "column",
    //28/10     
    flex: "0 1 auto",            
    minHeight: 0,   
          }}
        >
          {/* ---- Header Section ---- */}
  
         <div
    style={{
      overflowX: "auto",
      width: "100%",
      border: "1px solid #d9e1f2",   
      borderRadius: "8px",           
      boxSizing: "border-box",
    }}
  >
    <table
      style={{
        backgroundColor: "white",
        width: "100%",
        minWidth: "70vw",
        borderCollapse: "separate",  
        borderSpacing: 0,            
       
      }}
    >
              <thead>
                <tr
                   style={{
                    backgroundColor: "#2D79D9",
                    color: "white",
                    fontSize: "14px",
                    fontWeight: "600",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  <th style={{ ...thStyle, width: "60px", padding: "7px 10px" }}>Sr.No</th>
   <th style={{ ...thStyle, width: "120px", padding: "7px 10px" }}>
                    Financial Year
                  </th>
                  <th style={{ ...thStyle, width: "100px", padding: "7px 10px" }}>
                    Release ID
                  </th>
  
                 
  
                  <th style={{ ...thStyle, width: "220px", padding: "7px 10px" }}>
                    Project Name
                  </th>
  
                  <th style={{ ...thStyle, width: "130px", padding: "7px 10px" }}>
                    Release Amount
                  </th>
  
                  <th style={{ ...thStyle, width: "120px", padding: "7px 10px" }}>
                    Release Date
                  </th>
  
                  <th style={{ ...thStyle, width: "200px", padding: "7px 10px" }}>
                    Release Sanction Copy
                  </th>
  
  
                  {isMaker && (
                    <th style={{ ...thStyle, width: "150px", padding: "7px 10px" }}>
                      Remark
                    </th>
                  )}
                  <th style={{ ...thStyle,width:"150px",padding:"7px 10px"}}>Checker Approval</th>
                  {/* 18-09 */}
                  {isMaker && <th style={{ ...thStyle, width: "150px", padding: "7px 10px" }}>Action</th>}
  {isMaker && <th style={{ ...thStyle, width: "150px", padding: "7px 10px" }}>Approve</th>}
                </tr>
              </thead>
  
              <tbody>
                {currentBills?.map((fund, index) => {
                  return (
                    <tr
                      key={index}
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                        textAlign: "center",
                         backgroundColor: index % 2 === 0 ? "#E5F4FB" : "#CEE4F1",
                      }}
                    >
                      <td
                        style={{
                          padding: "10px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          border:"1px solid white"
                        }}
                      >
                        {indexOfFirstBill + index + 1}
                      </td>
  
                  
                      <td
                        style={{
                          padding: "10px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          border:"1px solid white"
                        }}
                      >
                        {fund.FinancialYear}
                      </td>
      <td
                        style={{
                          padding: "10px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          color:"blue",
                        border:"1px solid white"
                        }}
                      >
                        {fund.ReleaseID}
                      </td>
  
                      <td
                        style={{
                          padding: "10px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          border:"1px solid white"
                          // whiteSpace: "nowrap",
                        }}
                        title={fund.ProjectName}
                      >
                        {fund.ProjectName}
                      </td>
  
                      <td
                        style={{
                          padding: "10px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          border:"1px solid white"
                        }}
                      >
                        {/* {fund.ReleaseAmount} */}
                        ₹{Number(fund.ReleaseAmount || 0).toLocaleString("en-IN")}
                      </td>
  
                      <td
                        style={{
                          padding: "10px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          border:"1px solid white"
                        }}
                      >
                        {fund.ReleaseDate?.split("T")[0]}
                      </td>
  
                    
               <td style={{ padding: "8px", minWidth: "160px", width: "160px", maxWidth: "160px", whiteSpace: "nowrap", textAlign: "center", border:"1px solid white"}}>
    {fund.ReleaseSanctionCopy ? (
     <a
    href={`${apiurl}/ReleaseDocsImages/${encodeURIComponent(
      fund.ReleaseSanctionCopy
    )}`}
    target="_blank"
    rel="noopener noreferrer" 
    title={fund.ReleaseSanctionCopy}
    style={{display: "flex",alignItems: "center",  justifyContent: "center", gap: "5px", width: "100%", overflow: "hidden",textDecoration: "none", color: "#0d6efd", }}
  >  ReleaseSanctionCopy
  </a>
    ) : (
      <span style={{ color: "#d9534f", fontWeight: 700 }}>
        No File
      </span>
    )}
  </td>
                    
  
                      {isMaker && (
                        <td
                          style={{
                            padding: "10px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            border:"1px solid white"
                          }}
                          title={fund.Remark || "--"}
                        >
                          {fund.Remark || "--"}
                        </td>
                      )}
                      {/* 07-10 */}
                          <td
    style={{
      padding: "10px",
      textAlign: "center",
    }}
  >
    {fund.Status === "Approved" ? (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "6px",
          minWidth: "95px",
          padding: "5px 12px",
          border: "1px solid #39B54A",
          borderRadius: "20px",
          color: "#39B54A",
          backgroundColor: "#fff",
          fontSize: "12px",
          fontWeight: "600",
          whiteSpace: "nowrap",
        }}
      >
        <img
          src="/Approved  32 Size.png"
     
          alt="Approved"
          style={{
            width: "16px",
            height: "16px",
            objectFit: "contain",
          }}
        />
        Approved
      </span>
    ) : fund.Status === "Rejected" ? (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "6px",
          minWidth: "95px",
          padding: "5px 12px",
          border: "1px solid #ff5c6c",
          borderRadius: "20px",
          color: "#ff5c6c",
          backgroundColor: "#fff",
          fontSize: "12px",
          fontWeight: "600",
          whiteSpace: "nowrap",
        }}
      >
        <img
          src="/Reject 32 size.png"
          alt="Rejected"
          style={{
            width: "18px",
            height: "18px",
            objectFit: "contain",
          }}
        />
        Rejected
      </span>
    ) : fund.Status === "SendBack" ? (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "6px",
          minWidth: "95px",
          padding: "5px 12px",
          border: "1px solid #0d6efd",
          borderRadius: "20px",
          color: "#0d6efd",
          backgroundColor: "#fff",
          fontSize: "12px",
          fontWeight: "600",
          whiteSpace: "nowrap",
        }}
      >
        <img
          src="/send back 32 size.png"
          alt="Send Back"
          style={{
            width: "18px",
            height: "18px",
            objectFit: "contain",
          }}
        />
        Send Back
      </span>
    ) : (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "6px",
          minWidth: "95px",
          padding: "5px 12px",
          border: "1px solid orange",
          borderRadius: "20px",
          color: "#777",
          backgroundColor: "#fff",
          fontSize: "12px",
          fontWeight: "600",
        }}
      >
        <img
          src="/Pending icon 32 Size.png"
          alt="Send Back"
          style={{
            width: "18px",
            height: "18px",
            objectFit: "contain",
          }}
        />
   
        Pending
      </span>
    )}
  </td>
   
                      {isMaker && (
    <td style={{ padding: "10px", textAlign: "center",}}>
      <button
        onClick={() => handleEditFund(fund)}
        disabled={fund.Status !== "SendBack"}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "5px",
          margin: "auto",
          padding: "6px 12px",
          background:
            fund.Status === "SendBack" ? "#0D6EFD" : "rgba(141,141,141,0.97)",
          color: "#fff",
          border: "none",
          borderRadius: "6px",
          fontSize: "13px",
          fontWeight: "600",
          cursor: fund.Status === "SendBack" ? "pointer" : "not-allowed",
        }}
      >
        <img src={Edit32WHITE} alt="Edit" style={{ width: "14px", height: "14px" }} />
        Edit
      </button>
    </td>
  )}
  
  {isMaker && (
    <td style={{ padding: "10px", textAlign: "center" }}>
      <button
        onClick={() => handleApproveFund(fund)}
        disabled={fund.Status !== "SendBack"}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "5px",
          margin: "auto",
          padding: "6px 12px",
          background:
            fund.Status === "SendBack" ? "#39B54A" : "rgba(141,141,141,0.97)",
          color: "#fff",
          border: "none",
          borderRadius: "6px",
          fontSize: "13px",
          fontWeight: "600",
          cursor: fund.Status === "SendBack" ? "pointer" : "not-allowed",
        }}
      >
        <img src={Approved32} alt="Approve" style={{ width: "14px", height: "14px" }} />
        Approve
      </button>
    </td>
  )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {/*  */}
            {(!Array.isArray(currentBills) || currentBills.length === 0) && (  <div    style={{      position: "sticky",      left: 0,      width: "100%",      display: "flex",      justifyContent: "center",      alignItems: "center",      height: "150px",      boxSizing: "border-box",      backgroundColor: "#f9f9f9",      color: "black",      fontSize: "15px",      fontWeight: 500,    }}  >    No Limit Allocation found  </div>)}
          </div>
  
          {/* ---- Pagination ---- */}
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "15px",
              padding: "10px 5px",
              boxSizing: "border-box",
              flexShrink:0
            }}
          >
            {/* Showing */}
            <div
              style={{
                fontSize: "13px",
                color: "#333",
                whiteSpace: "nowrap",
              }}
            >
              Showing {filteredBills?.length === 0 ? 0 : indexOfFirstBill + 1} to{" "}
              {Math.min(indexOfLastBill, filteredBills?.length || 0)} of{" "}
              {filteredBills?.length || 0} entries
            </div>
  
            {/* Pagination */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "18px",
              }}
            >
              {/* Previous */}
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                style={{
                  border: "none",
                  background: "transparent",
                  color: currentPage === 1 ? "#999" : "#2ea4e7",
                  cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  fontSize: "13px",
                  padding: 0,
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  opacity: currentPage === 1 ? 0.5 : 1,
                }}
              >
                <span style={{ fontSize: "20px" }}>‹</span>
                Previous
              </button>
  
              {/* Page Numbers */}
              {getPageNumbers(currentPage, totalPages).map(
                (pageNumber, index) => {
                  // Dots ko button mat banana
                  if (pageNumber === "...") {
                    return (
                      <span
                        key={`ellipsis-${index}`}
                        style={{
                          fontSize: "13px",
                          color: "#444",
                        }}
                      >
                        ...
                      </span>
                    );
                  }
  
                  return (
                    <button
                      key={pageNumber}
                      onClick={() => setCurrentPage(pageNumber)}
                      style={{
                        border: "none",
                        background: "transparent",
                        padding: 0,
                        color: currentPage === pageNumber ? "#2ea4e7" : "#444",
                        cursor: "pointer",
                        fontSize: "13px",
                        fontWeight: currentPage === pageNumber ? "600" : "400",
                        textDecoration:
                          currentPage === pageNumber ? "underline" : "none",
                      }}
                    >
                      {pageNumber}
                    </button>
                  );
                },
              )}
              {/* Next */}
              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages || totalPages === 0}
                style={{
                  border: "none",
                  background: "transparent",
                  color:
                    currentPage === totalPages || totalPages === 0
                      ? "#999"
                      : "#2ea4e7",
                  cursor:
                    currentPage === totalPages || totalPages === 0
                      ? "not-allowed"
                      : "pointer",
                  fontSize: "13px",
                  padding: 0,
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  opacity:
                    currentPage === totalPages || totalPages === 0 ? 0.5 : 1,
                }}
              >
                Next
                <span style={{ fontSize: "20px" }}>›</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      </div>
      ) : (
        <div
          style={{
            width: "100%",
            padding: "20px",
            background: "#f5f7fb",
            minHeight: "100vh",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "15px",
            }}
          >
            <button
              onClick={() => {
                setOpenEdit(false);
                setEditData(null);
              }}
              style={{
                background: "#0d6efd",
                color: "#fff",
                border: "none",
                padding: "10px 18px",
                borderRadius: "8px",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              ← Back
            </button>
          </div>
  
          <LimitAllocation
            isEdit={true}
            projectDatainward={editData}
            onSuccess={() => {
              setOpenEdit(false);
              setEditData(null);
              getFundList(); // refresh outward table
            }}
            onCancel={() => {
              setOpenEdit(false);
              setEditData(null);
            }}
          />
        </div>
      )}
      </>
    );
};

export default LimitAllocationOutwardList;
